import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

export default function Ejemplo3() {
  return (
    <>
      <header>
        <Navbar />
      </header>

      <main>
        <section className="py-12 bg-sidom-light dark:bg-sidom-blue text-center">
          <h2 className="text-3xl font-bold mb-4">Sección 1 - Ejemplo 3</h2>
          <p>Contenido de la primera sección de Ejemplo 3.</p>
        </section>
        <section className="py-12 bg-sidom-orange/10 text-center">
          <h2 className="text-3xl font-bold mb-4">Sección 2 - Ejemplo 3</h2>
          <p>Contenido de la segunda sección de Ejemplo 3.</p>
        </section>
        <section className="py-12 bg-sidom-blue/10 text-center">
          <h2 className="text-3xl font-bold mb-4">Sección 3 - Ejemplo 3</h2>
          <p>Contenido de la tercera sección de Ejemplo 3.</p>
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}
